import { render, staticRenderFns } from "./editSubsidy.vue?vue&type=template&id=d0090802"
import script from "./editSubsidy.vue?vue&type=script&lang=js"
export * from "./editSubsidy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports